var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper",class:!_vm.minibar ? '' : 'mini-sidebar'},[_c('Header'),_vm._v(" "),_c('Sidebar'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bdb0834","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/talenta.vue
// module id = null
// module chunks = 